import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { EMAIL_REGEX } from './email.validator';

export function EmailWithOtpValidator(control: AbstractControl, field: FormlyFieldConfig) {
  const value = control.value;
  const required = field.props?.required ?? false;
  const verified = field.props?.['emailVerified'] ?? false;

  // If the control value is missing, return an error
  if (required && !value?.email) {
    return { required: true };
  } else if (!value.email) {
    return null;
  }
  const errors: { [key: string]: boolean } = {};

  // Validate email format
  if (!EMAIL_REGEX.test(value.email)) {
    errors['invalidEmailAddress'] = true;
  }

  // Validate OTP format (4 digits)
  const otpRegex = /^\d{4}$/;

  if (!otpRegex.test(value.code) && !verified) {
    errors['invalidOtp'] = true;
  }

  // If there are any errors, return them; otherwise, return null
  return Object.keys(errors).length > 0 ? errors : null;
}
